import React, { useState } from 'react';

const ReportButton = ({ label, icon: Icon, onClick, loading = false, disabled = false }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        if (disabled || isLoading) return;

        setIsLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (onClick) onClick();
        } catch (err) {
            console.error("Download failed", err);
        } finally {
            setIsLoading(false);
        }
    };

    const buttonStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: isLoading ? 'center' : 'flex-start',
        padding: '10px',
        width: '288px',
        height: '112px',
        backgroundColor: isHovered ? '#d3efe2' : 'white',
        borderRadius: '8px',
        boxShadow: isHovered ? '0 6px 16px rgba(0, 0, 0, 0.15)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
        position: 'relative',
        overflow: 'hidden',
    };

    const iconContainerStyle = {
        display: isLoading ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '56px',
        height: '56px',
        minWidth: '56px',       
        minHeight: '56px',      
        flexShrink: 0,          
        borderRadius: '50%',
        background: isHovered
            ? 'linear-gradient(to right,rgb(66, 194, 156),rgb(79, 214, 86))'
            : 'linear-gradient(to right,rgb(107, 174, 230), #A2E9C1)',
        boxShadow: isHovered
            ? '0 6px 12px rgba(0, 0, 0, 0.2)'
            : '0 4px 8px rgba(0, 0, 0, 0.2)',
        transition: 'background 0.3s ease, transform 0.3s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
    };

    const iconStyle = {
        fontSize: '28px',
        fill: '#4B5563',
        transition: 'fill 0.3s ease',
        ...(isHovered && { fill: '#1F2937' }),
    };

    const labelStyle = {
        marginLeft: '16px',
        fontSize: '18px',
        fontWeight: 'bold',
        color: isHovered ? '#1F2937' : '#4B5563',
        textTransform: 'capitalize',
        transition: 'color 0.3s ease',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        display: isLoading ? 'none' : 'inline',
    };

    const spinnerStyle = {
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #4B5563',
        borderRadius: '50%',
        width: '32px',
        height: '32px',
        animation: 'spin 1s linear infinite',
        position: 'absolute',
    };

    return (
        <>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
            <button
                style={buttonStyle}
                onClick={handleClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                disabled={disabled || isLoading}
            >
                {isLoading ? (
                    <div style={spinnerStyle}></div>
                ) : (
                    <>
                        <section style={iconContainerStyle}>
                            <Icon style={iconStyle} />
                        </section>
                        <span style={labelStyle}>{label}</span>
                    </>
                )}
            </button>
        </>
    );
};

export default ReportButton;
